import { DropTarget } from 'react-dnd';
import { throttle } from 'lodash';
import { ItemTypes } from 'constants/itemTypes';

const scrollPage = diff => () => {
  const scrollTop = $(document).scrollTop();
  $(document).scrollTop(scrollTop + diff);
};

const [UP_DIFF, DOWN_DIFF] = [-5, 5];
const scrollUp = throttle(scrollPage(UP_DIFF), 5);
const scrollDown = throttle(scrollPage(DOWN_DIFF), 5);

export default DropTarget(
  // TODO make this composable
  [ItemTypes.ELEMENT, ItemTypes.PATH_STEP, ItemTypes.INTERACTION],
  {
    hover(props, monitor, component) {
      const is = val => props.direction === val;
      if (is('up')) scrollUp();
      else if (is('down')) scrollDown();
    },
    canDrop(props, monitor, component) {
      return false;
    },
  },
  connector => ({
    connectDropTarget: connector.dropTarget(),
  }),
);
